import { EpsonBarcodeFormat } from './epson_barcode_format.js';

export function name(barcodeFormat: EpsonBarcodeFormat): string {
  switch (barcodeFormat) {
    case EpsonBarcodeFormat.UPC_A:
      return 'UPC A';
    case EpsonBarcodeFormat.UPC_E:
      return 'UPC E';
    case EpsonBarcodeFormat.EAN13:
      return 'EAN13';
    case EpsonBarcodeFormat.JAN13:
      return 'JAN13';
    case EpsonBarcodeFormat.EAN8:
      return 'EAN8';
    case EpsonBarcodeFormat.JAN8:
      return 'JAN8';
    case EpsonBarcodeFormat.CODE128:
      return 'CODE128';
    // case EpsonBarcodeFormat.CODE39:
    // case EpsonBarcodeFormat.ITF:
    // case EpsonBarcodeFormat.CODABAR:
    // case EpsonBarcodeFormat.CODE93:
    // case EpsonBarcodeFormat.GS1_128:
    // case EpsonBarcodeFormat.GS1_DATABAR_OMNIDIRECTIONAL:
    // case EpsonBarcodeFormat.GS1_DATABAR_TRUNCATED:
    // case EpsonBarcodeFormat.GS1_DATABAR_LIMITED:
    // case EpsonBarcodeFormat.GS1_DATABAR_EXPANDED:
  }
}
